import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "my-8" }
const _hoisted_3 = { class: "my-8" }
const _hoisted_4 = { class: "my-8" }
const _hoisted_5 = { class: "my-12 d-flex justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_time_input = _resolveComponent("time-input")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_ctx.inputValue)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_form, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h5", null, _toDisplayString(_ctx.$t('nurseryHours.extendedPatternName')), 1),
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.inputValue.patternTitle,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue.patternTitle) = $event)),
                variant: "outlined",
                "hide-details": "",
                density: "compact"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h5", null, _toDisplayString(_ctx.$t('nurseryHours.amount')), 1),
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.inputValue.billingAmount,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inputValue.billingAmount) = $event)),
                rules: [_ctx.isSafeInteger, _ctx.isNotMinus],
                variant: "outlined",
                density: "compact",
                "hide-details": "",
                type: "number",
                suffix: "円"
              }, null, 8, ["modelValue", "rules"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h5", null, _toDisplayString(_ctx.$t('nurseryHours.extendedCareStartTime')), 1),
              _createVNode(_component_time_input, {
                hour: _ctx.inputValue.extendedChildcareStartingHour,
                onHour: _cache[2] || (_cache[2] = ($event: any) => (_ctx.inputValue.extendedChildcareStartingHour = Number($event))),
                minute: _ctx.inputValue.extendedChildcareStartingMinute,
                onMinute: _cache[3] || (_cache[3] = ($event: any) => (_ctx.inputValue.extendedChildcareStartingMinute = Number($event)))
              }, null, 8, ["hour", "minute"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              (_ctx.isUpdatable)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    onClick: _ctx.updatePattern,
                    loading: _ctx.isLoading,
                    color: "primary",
                    variant: "flat",
                    large: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick", "loading"]))
                : (_openBlock(), _createBlock(_component_v_btn, {
                    key: 1,
                    onClick: _ctx.createPattern,
                    loading: _ctx.isLoading,
                    color: "primary",
                    variant: "flat",
                    large: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('common.create')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick", "loading"]))
            ])
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}